// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Mongolia */
const MN =
  /^(?:(?:87[01]|92[0139])\d{5}|(?:5[05]|6[069]|7[28]|8[0135689]|9[013-9])\d{6})$/;

export default MN;
